var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallGroupTrees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 73,
    viewBox: "0 0 240 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 56.5881,
    cy: 30.6818,
    r: 30.6818,
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 18.4091,
    cy: 47.0458,
    r: 18.4091,
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 56.4063,
    y1: 19.5898,
    x2: 56.4063,
    y2: 71.7717,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.3399,
    y1: 44.793,
    x2: 55.9055,
    y2: 56.3586,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 16.8563,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 69.5391 30)",
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 18.375,
    y1: 40.6641,
    x2: 18.375,
    y2: 71.7738,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.1759,
    y1: 55.6836,
    x2: 17.8787,
    y2: 62.3864,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 9.97925,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 26.1094 46.75)",
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    r: 30.6818,
    transform: "matrix(-1 0 0 1 153.412 30.6818)",
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    r: 18.4091,
    transform: "matrix(-1 0 0 1 191.591 47.0458)",
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    r: 18.4091,
    transform: "matrix(-1 0 0 1 221.591 47.0458)",
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    r: 18.4091,
    transform: "matrix(-1 0 0 1 115.224 47.0458)",
    fill: "#00B288"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 52.6818,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 154.094 19.0898)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 16.8563,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 166.367 44.793)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.168,
    y1: 30,
    x2: 152.734,
    y2: 41.5656,
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 31.6098,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 192.125 40.1641)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 9.97925,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 199.531 55.6836)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.598,
    y1: 46.75,
    x2: 191.301,
    y2: 53.4528,
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 31.6098,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 222.125 40.1641)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 9.97925,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 229.531 55.6836)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.598,
    y1: 46.75,
    x2: 221.301,
    y2: 53.4528,
    stroke: "black",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 31.6098,
    y2: -0.5,
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 115.758 40.1641)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 9.97925,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 123.164 55.6836)",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.231,
    y1: 46.75,
    x2: 114.933,
    y2: 53.4528,
    stroke: "black",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGroupTrees);
export default __webpack_public_path__ + "static/media/small-group-trees.ab5fcd38.svg";
export { ForwardRef as ReactComponent };